import { useEffect, useRef, useState } from "react";
import { Volume2 } from "lucide-react";

export const IntroSplash = ({ onDone }) => {
  const ref = useRef(null);
  const doneRef = useRef(false);
  const [fading, setFading] = useState(false);
  const [needsTap, setNeedsTap] = useState(false);

  const finish = () => {
    if (doneRef.current) return;
    doneRef.current = true;
    window.__introActive = false;
    setFading(true);
    setTimeout(onDone, 450);
  };

  const unlockSound = () => {
    const v = ref.current;
    if (v && v.muted) {
      v.muted = false;
      v.volume = 1;
      v.play().catch(() => {});
    }
    setNeedsTap(false);
  };

  useEffect(() => {
    window.__introActive = true; // suppress notification chime while the intro plays
    const v = ref.current;
    if (v) {
      v.muted = false;
      v.volume = 1;
      v.play().then(() => setNeedsTap(false)).catch(() => {
        // Browser blocked autoplay with sound — play muted and unmute on first interaction
        v.muted = true;
        v.play().catch(() => {});
        setNeedsTap(true);
      });
    }
    window.addEventListener("pointerdown", unlockSound);
    window.addEventListener("keydown", unlockSound);
    const safety = setTimeout(finish, 12000);
    return () => {
      window.__introActive = false;
      window.removeEventListener("pointerdown", unlockSound);
      window.removeEventListener("keydown", unlockSound);
      clearTimeout(safety);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`fixed inset-0 z-[200] bg-white flex items-center justify-center transition-opacity duration-500 ${fading ? "opacity-0" : "opacity-100"}`}
         data-testid="intro-splash">
      <video ref={ref} src="/intro.mp4" autoPlay playsInline preload="auto"
             className="w-full h-full object-contain"
             onEnded={finish} onError={finish} data-testid="intro-video" />
      {needsTap && (
        <button onClick={unlockSound}
                className="absolute bottom-8 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 text-xs font-semibold text-white bg-slate-900/80 backdrop-blur rounded-full px-4 py-2 animate-pulse"
                data-testid="intro-sound-btn">
          <Volume2 size={14} /> Tap anywhere for sound
        </button>
      )}
      <button onClick={finish}
              className="absolute bottom-8 right-8 text-xs font-semibold uppercase tracking-widest text-slate-500 hover:text-slate-800 border border-slate-300 hover:border-slate-500 rounded-full px-4 py-2 bg-white/80 backdrop-blur transition-colors duration-200"
              data-testid="intro-skip">
        Skip →
      </button>
    </div>
  );
};
